module.exports = __webpack_public_path__ + "static/media/Facebook-Icon--inverse.ddf0f7cb.svg";